module.exports = __webpack_public_path__ + "static/img/id2.5b5c65c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/id2.png
// module id = /8FV
// module chunks = 1